import React, { useState } from "react";
import "../../styles/canteen.css";

const canteenImages = [
  { id: 2, src: "/images/IMG_9997.jpg", alt: "Canteen Image 2" },
];

const paceMartImages = [
  { id: 5, src: "/images/IMG_9937.jpg", alt: "Pace Mart Image 2" },
];

const CanteenGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="canteen-container">
      <h1 className="canteen-heading">CAMPUS DINING</h1>

      {/* Canteen Section */}
      <div className="canteen-section">
        <h2 className="section-title">CANTEEN</h2>
        <div className="yellow-dashed-line"></div>
        <div className="canteen-grid">
          <div className="canteen-description">
            <p>
              The campus canteen at P.A. Polytechnic is more than just a place to eat — it's a vibrant social hub where students gather, relax, and refuel. The facility offers a wide variety of nutritious and delicious food options catering to different tastes and dietary needs. From traditional Indian meals to light snacks and beverages, the menu is thoughtfully curated to support student well-being and energy throughout the day.
            </p>
            <p>
              With a strong emphasis on hygiene and quality, the canteen maintains a clean, safe, and welcoming environment. The seating area is spacious and well-ventilated, allowing students to enjoy their meals in comfort. The kitchen is equipped with modern appliances and adheres to strict food safety standards. Whether it’s a quick breakfast before class, a full lunch during breaks, or an evening snack, the canteen is always ready to serve the campus community efficiently and courteously.
            </p>
          </div>
          <div className="canteen-images">
            {canteenImages.map((image) => (
              <img
                key={image.id}
                src={image.src}
                alt={image.alt}
                onClick={() => setSelectedImage(image)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Pace Mart Section */}
      <div className="canteen-section">
        <h2 className="section-title">PACE MART (Cafe)</h2>
        <div className="yellow-dashed-line"></div>
        <div className="canteen-grid">
          <div className="canteen-description">
            <p>
              Pace Mart, our in-house café, serves as the perfect hangout spot for students and staff. Designed with a modern café atmosphere, it offers an assortment of snacks, quick bites, cool beverages, and fresh coffee — making it the go-to destination for casual meetups and study breaks.
            </p>
            <p>
              In addition to refreshments, Pace Mart provides essential convenience items and packed foods. Its cozy setup, friendly service, and consistent availability make it an integral part of everyday campus life. Whether you're in need of a quick energy boost between lectures or a relaxing cup of tea in the evening, Pace Mart ensures quality service with a smile.
            </p>
          </div>
          <div className="canteen-images">
            {paceMartImages.map((image) => (
              <img
                key={image.id}
                src={image.src}
                alt={image.alt}
                onClick={() => setSelectedImage(image)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
          <div className="modal-content">
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="modal-image"
            />
            <span className="close-button" onClick={() => setSelectedImage(null)}>
              ×
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default CanteenGallery;
